import React, { useState } from 'react'
import LookupForm from './warranty/LookupForm'
import RegisterForm from './warranty/RegisterForm'
import ResultWrapper from './Result'

export default WarrantyApp = () => {
  const [mode, setMode] = useState(null)
  const [result, setResult] = useState(null)
  const [serial, setSerial] = useState(null)
  const backToHome = () => {
    setSerial(null)
    setResult(null)
    setMode(null)
  }
  return (
    <>
      {mode === null && (
        <LookupForm
          serial={serial}
          setSerial={setSerial}
          setMode={setMode}
          setResult={setResult}
        />
      )}
      {mode === 'ShowResult' && (
        <ResultWrapper result={result} backToHome={backToHome} />
      )}
      {mode === 'Register' && (
        <RegisterForm result={result} serial={serial} backToHome={backToHome} />
      )}
    </>
  )
}
